import './Toast.scss'
import { useEffect } from 'react'

interface Props {
    message: string
    actionLabel?: string
    onAction?: () => void
    onClose: () => void
    duration?: number
}

// Barre en bas de page, avec une action (« Annuler »), qui disparaît seule.
const Toast = ({ message, actionLabel, onAction, onClose, duration = 8000 }: Props) => {
    useEffect(() => {
        const timeout = setTimeout(onClose, duration)
        return () => clearTimeout(timeout)
    }, [message, onClose, duration])

    return <div className="tl-toast" role="status">
        <span>{ message }</span>
        { actionLabel && onAction && <button onClick={onAction}>{ actionLabel }</button> }
        <button className="close" title="Fermer" onClick={onClose}><i className="fa-solid fa-xmark"/></button>
    </div>
}

export default Toast
